import { useDispatch, useSelector } from 'react-redux';
import { Fragment, useState } from 'react';
import { components } from 'react-select';
import Select from 'react-select';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getChapters, getTopics } from '../../Redux/ActionCreators/manageContentAction';
import { editSchedule, getClassAndAffiliation, getFaculties, getSections, getStudents } from '../../Redux/ActionCreators/scheduleAction';
import { trackUserLogin } from '../../Redux/ActionCreators/layoutAction';
import "./schedule.scss";

const DropdownIndicator = props => {
    return (
        <components.DropdownIndicator {...props}>
            <img src='/images/select-indicator.svg' alt='' />
        </components.DropdownIndicator>
    );
};

function ViewClass(props) {
    const [subject, setSubject] = useState(null);
    const [classId, setClassId] = useState('');
    const [classType, setClassType] = useState('');
    const [classUrl, setClassUrl] = useState('');
    const [faculty, setFaculty] = useState(null);
    const [title, setTitle] = useState('');
    const [topic, setTopic] = useState(null);
    const [chapter, setChapter] = useState(null);
    const [sections, setSections] = useState([]);
    const [students, setStudents] = useState([]);
    const [date, setDate] = useState('');
    const [fromTime, setFromTime] = useState('');
    const [toTime, setToTime] = useState('');
    const [subjectError, setSubjectError] = useState('');
    const [classTypeError, setClassTypeError] = useState('');
    const [classUrlError, setClassUrlError] = useState('');
    const [facultyError, setFacultyError] = useState('');
    const [titleError, setTitleError] = useState('');
    const [topicError, setTopicError] = useState('');
    const [chapterError, setChapterError] = useState('');
    const [sectionsError, setSectionsError] = useState('');
    const [dateError, setDateError] = useState('');
    const [fromTimeError, setFromTimeError] = useState('');
    const [toTimeError, setToTimeError] = useState('');
    const [activeTab, setActiveTab] = useState(props.schedule.sections.length > 0 ? 'sections' : 'students'); // 'sections' or 'students'

    const {edit, setEdit, schedule, goToSchedule, subjectList, getSchedule} = props;
    const { classAndAffiliation, faculties, sectionsList, studentsList } = useSelector(state => state.schedule);
    const { chapterList, topicsList } = useSelector(state => state.manageContent);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    
    useEffect(() => {
        async function firstRender() {
            if(schedule) {
                setClassId(schedule._id);
                setSubject({
                    value: schedule.subject._id,
                    label: schedule.subject.name
                });
                setFaculty(schedule.faculty ? {
                    value: schedule.faculty?._id,
                    label: schedule.faculty.firstname + ' ' + schedule.faculty.lastname
                } : null);
                setSections(schedule.sections.map(section => ({
                    value: section._id,
                    label: section.name
                })));
                setStudents(schedule.students.map(student => ({
                    value: student._id,
                    label: student.firstname + ' ' + student.lastname
                })));
                setTopic({
                    value: schedule.topic._id,
                    label: schedule.topic.name
                });
                setChapter({
                    value: schedule.chapter._id,
                    label: schedule.chapter.name
                });
                setTitle(schedule?.title);
                setClassType(schedule?.class_type);
                setClassUrl(schedule?.class_url);
                setFromTime(formatTime(schedule?.from));
                setToTime(formatTime(schedule?.to));
                const formattedDate = schedule.date ? new Date(schedule.date).toISOString().split('T')[0] : '';
                setDate(formattedDate);
                dispatch(getChapters(schedule.subject._id));
                dispatch(getTopics(schedule.chapter._id));
                dispatch(getFaculties(schedule.affiliation._id, schedule.subject._id));
                const classAffiliation = await dispatch(getClassAndAffiliation(schedule.subject._id));
                await dispatch(getSections(classAffiliation.payload.class._id));
                await dispatch(getStudents(classAffiliation.payload.class._id));
            }
        }
        firstRender();
    }, []);

    const formatTime = (timeStr) => {
        if (!timeStr) return '';
        return timeStr.split(':').map(part => part.padStart(2, '0')).join(':');
    };

    const handleSubject = async(selectedOption) => {
        await dispatch(getChapters(selectedOption.value));
        const classAffiliation = await dispatch(getClassAndAffiliation(schedule.subject._id));
        await dispatch(getSections(classAffiliation.payload.class._id));
        await dispatch(getStudents(classAffiliation.payload.class._id));
        await dispatch(getFaculties(classAffiliation.payload.affiliation._id, selectedOption.value));
        setSubject(selectedOption);
        setChapter(null);
        setTopic(null);
        setFaculty(null);
        setSections([]);
        setStudents([]);
    }

    const handleChapter = (selectedOption) => {
        dispatch(getTopics(selectedOption.value));
        setChapter(selectedOption);
        setTopic(null);
    }

    const handleTopic = (selectedOption) => {
        setTopic(selectedOption);
    }

    const handleFaculty = (selectedOption) => {
        setFaculty(selectedOption);
    }

    const selectStudents = (selectedOptions) => {
        setStudents(selectedOptions);
        setSectionsError('');
    };

    const selectSections = (selectedOptions) => {
        setSections(selectedOptions);
        setSectionsError('');
    };

    const editStudent= async ()=>{
        if (!subject) {
            setSubjectError('Please select a subject');
            return;
        }
        if (!faculty) {
            setFacultyError('Please select a faculty');
            return;
        }
        if (!title) {
            setTitleError('Please enter a title');
            return;
        }
        if (!sections.length && !students.length) {
            setSectionsError('Please select at least one section or student');
            return;
        }
        if (!chapter) {
            setChapterError('Please select a chapter');
            return;
        }
        if (!topic) {
            setTopicError('Please select a topic');
            return;
        }
        if (!classType) {
            setClassTypeError('Please select a class type');
            return;
        }
        if (!classUrl && classType === 'online') {
            setClassUrlError('Please enter a class URL');
            return;
        }
        if (!date) {
            setDateError('Please select a date');
            return;
        }
        if (!fromTime) {
            setFromTimeError('Please select a from time');
            return;
        }
        if (!toTime) {
            setToTimeError('Please select a to time');
            return;
        }
        if (classType === 'online') {
            if (!classUrl) {
                setClassUrlError('Class URL is required for online classes');
                return;
            } else {
                // Basic URL validation
                const urlPattern = /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?$/;
                if (!urlPattern.test(classUrl)) {
                    setClassUrlError('Please enter a valid URL (e.g., https://example.com)');
                    return;
                }
            }
        }
        if(activeTab === 'sections') {
            if(sections.length > 1) {
                setSectionsError('You can select only one section while editing');
                return;
            }
        }
        
        // Validate that toTime is after fromTime
        if (fromTime && toTime) {
            const fromTime1 = new Date(`1970-01-01T${fromTime}`);
            const toTime1 = new Date(`1970-01-01T${toTime}`);
            
            if (fromTime1 >= toTime1) {
                setToTimeError('End time must be after start time');
                return;
            }
        }
        const data = {
                class_id: classId,
                title: title,
                date: date,
                from: fromTime,
                to: toTime,
                faculty_id: localStorage.getItem('role') === 'faculty' ? JSON.parse(localStorage.getItem('profileDetails'))._id : faculty.value,
                subject_id: subject.value,
                chapter_id: chapter.value,
                topic_id: topic.value,
                classroom_id: classAndAffiliation.class._id,
                affiliation_id: classAndAffiliation.affiliation._id,
                ...(activeTab === 'sections' ? { section_ids: sections.map(st => st.value) } : { student_ids: students.map(st => st.value) }),
            };
        await dispatch(editSchedule(data));
        goToSchedule();
        await getSchedule();
    }

    return (
        <div className='view-form'>
            <div className='add-class-form'>
                <div className='class-header' style={{ width: edit ? '55%' : '100%' }}>
                    <img onClick={goToSchedule} src='/images/back1.svg' alt='' />
                    <p>{edit ? 'Edit Class' : 'View Class'}</p>
                    {
                        !edit ?
                            <h3 className='cursor-pointer' onClick={() => setEdit(true)}><img src='/images/edit-layout-icon.svg' alt='' />&nbsp; Edit</h3>
                            : null
                    }
                </div>
                <div className='form-inputs'>
                    <div className='row mt-1'>
                        <div className='col-lg-5'>
                            <div className='form-group mt-2'>
                                <label>Subject*
                                </label>
                                <Select
                                    components={{ DropdownIndicator }}
                                    placeholder='Select Subject'
                                    value={subject}
                                    onChange={handleSubject}
                                    options={subjectList}
                                    isDisabled={!edit}
                                />
                                <span>{subjectError}</span>
                            </div>
                        </div>
                        <div className='col-lg-5'>
                            <div className='form-group mt-2'>
                                <label>Chapter*
                                </label>
                                <Select
                                    components={{ DropdownIndicator }}
                                    placeholder='Select Chapter'
                                    value={chapter}
                                    onChange={handleChapter}
                                    options={chapterList.map(chapter => ({ value: chapter._id, label: chapter.name }))}
                                    isDisabled={!edit}
                                />
                                <span>{chapterError}</span>
                            </div>
                        </div>
                    </div>
                    <div className='row mt-1'>
                        <div className='col-lg-5'>
                            <div className='form-group mt-2'>
                                <label>Class Name*
                                </label>
                                <input className='form-control mt-2 text-capitalize' style={{ border: '1px solid #5EB5E7' }} disabled={!edit} maxLength='50' name='lastname' value={title} onChange={(e) => setTitle(e.target.value)} placeholder='Enter class name'/>
                                <span style={{ color: 'red', fontSize: 14 }}>{titleError}</span>
                            </div>
                        </div>
                        <div className='col-lg-5'>
                            <div className='form-group mt-2'>
                                <label>Topic*
                                </label>
                                <Select
                                    components={{ DropdownIndicator }}
                                    placeholder='Select Topic'
                                    value={topic}
                                    onChange={handleTopic}
                                    options={topicsList.map(topic => ({ value: topic._id, label: topic.name }))}
                                    isDisabled={!edit}
                                />
                                <span>{topicError}</span>
                            </div>
                        </div>
                    </div>
                    <div className='row mt-2'>
                        {!(localStorage.getItem('role') === 'faculty') && 
                            <div className='col-lg-5'>
                                <div className='form-group mt-2'>
                                    <label>Faculty*
                                    </label>
                                    <Select
                                        components={{ DropdownIndicator }}
                                        placeholder='Select Faculty'
                                        value={faculty}
                                        onChange={handleFaculty}
                                        options={faculties}
                                        isDisabled={!edit}
                                    />
                                    <span style={{ color: 'red', fontSize: 14 }}>{facultyError}</span>
                                </div>
                            </div>
                        }
                        <div className={localStorage.getItem('role') === 'faculty' ? 'col-lg-10': 'col-lg-5'}>
                            <div className='row'>
                                <div className='col-lg-4 pe-1'>
                                    <div className='form-group mt-2'>
                                        <label>Date*
                                        </label>
                                        <input className='form-control mt-2' type='date' style={{ border: '1px solid #5EB5E7' }} disabled={!edit} name='date' value={date} onClick={(e) => e.target.showPicker()} onChange={(e) => setDate(e.target.value)} />
                                        <span style={{ color: 'red', fontSize: 14 }}>{dateError}</span>
                                    </div>
                                </div>
                                <div className='col-lg-4 px-1'>
                                    <div className='form-group mt-2'>
                                        <label>From Time*
                                        </label>
                                        <input className='form-control mt-2' type='time' disabled={!edit} name='fromTime' value={fromTime} style={{ border: '1px solid #5EB5E7' }} onClick={(e) => e.target.showPicker()} onChange={(e) => setFromTime(e.target.value)} />
                                        <span style={{ color: 'red', fontSize: 14 }}>{fromTimeError}</span>
                                    </div>
                                </div>
                                <div className='col-lg-4 ps-1'>
                                    <div className='form-group mt-2'>
                                        <label>To Time*
                                        </label>
                                        <input className='form-control mt-2' type='time' disabled={!edit} name='toTime' value={toTime} style={{ border: '1px solid #5EB5E7' }} onClick={(e) => e.target.showPicker()} onChange={(e) => setToTime(e.target.value)} />
                                        <span style={{ color: 'red', fontSize: 14 }}>{toTimeError}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row mt-1'>
                        <div className='col-lg-5'>
                            <div className='form-group mt-2'>
                                <label>Class Type*
                                </label>
                                <select className='form-control mt-2 text-capitalize' style={{ border: '1px solid #5EB5E7' }} disabled={!edit} 
                                value={classType} 
                                onChange={e => {
                                    setClassType(e.target.value);
                                    if(e.target.value === 'offline') {
                                        setClassUrl('');
                                    }
                                }}>
                                    <option value="online">Online</option>
                                    <option value="offline">Offline</option>
                                </select>
                                <span style={{ color: 'red', fontSize: 14 }}>{classTypeError}</span>
                            </div>
                        </div>
                        <div className='col-lg-5'>
                            <div className='form-group mt-2'>
                                <label>Class Url*
                                </label>
                                <input className='form-control mt-2' style={{ border: '1px solid #5EB5E7' }} disabled={!edit || classType === 'offline'} name='classUrl' value={classUrl} onChange={(e) => setClassUrl(e.target.value)} placeholder={classType === 'online' ? 'Enter meeting URL' : 'N/A'}/>
                                <span style={{ color: 'red', fontSize: 14 }}>{classUrlError}</span>
                            </div>
                        </div>
                    </div>
                    <div className='select-batches'>
                    <div className='tabs-container mb-3'>
                        <div 
                            className={`tab ${activeTab === 'sections' ? 'active' : ''}`}
                            onClick={() => setActiveTab('sections')}
                        >
                            Sections
                        </div>
                        <div 
                            className={`tab ${activeTab === 'students' ? 'active' : ''}`}
                            onClick={() => setActiveTab('students')}
                        >
                            Students
                        </div>
                    </div>
                    
                    {activeTab === 'sections' ? (
                        <>
                            <label>Select Sections*</label>
                            <Select
                                isMulti
                                className="basic-multi-select"
                                classNamePrefix="select"
                                components={{ DropdownIndicator }}
                                placeholder='Select Sections'
                                options={sectionsList || []}
                                closeMenuOnSelect={false}
                                hideSelectedOptions={trackUserLogin}
                                isClearable={true}
                                isSearchable={true}
                                value={sections}
                                onChange={selectSections}
                                getOptionLabel={option => option.label}
                                getOptionValue={option => option.value}
                                isDisabled={!edit ||!subject}
                            />
                        </>
                    ) : (
                        <>
                            <label>Select Students*</label>
                            <Select
                                isMulti
                                className="basic-multi-select"
                                classNamePrefix="select"
                                components={{ DropdownIndicator }}
                                placeholder='Select Students'
                                options={studentsList || []}
                                closeMenuOnSelect={false}
                                hideSelectedOptions={trackUserLogin}
                                isClearable={true}
                                isSearchable={true}
                                value={students}
                                onChange={selectStudents}
                                getOptionLabel={option => option.label}
                                getOptionValue={option => option.value}
                                isDisabled={!edit || !subject}
                            />
                        </>
                    )}
                    <span>{sectionsError}</span>
                </div>
                    {
                        edit ?
                            <Fragment>
                                <hr style={{ borderTop: '1px solid #DDDDE2' }} />
                                <div className='save-btn'>
                                    <button onClick={editStudent}>Save</button>
                                    <button onClick={goToSchedule}>Cancel</button>
                                </div>
                            </Fragment>
                            : null
                    }

                </div>
            </div>
        </div>
    );
}

export default ViewClass;
